import { render, staticRenderFns } from "./reserveFlight.vue?vue&type=template&id=b2f63d94&scoped=true&"
import script from "./reserveFlight.vue?vue&type=script&lang=js&"
export * from "./reserveFlight.vue?vue&type=script&lang=js&"
import style0 from "./reserveFlight.vue?vue&type=style&index=0&id=b2f63d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f63d94",
  null
  
)

export default component.exports